module.exports = __webpack_public_path__ + "img/PCP Express.a5357fc2.png";